<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/data/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    3096,
    3059,
    3161,
    3000,
    3419,
    3385,
    4263,
    5012,
    5669,
    6502,
    7626,
    8745,
    8377,
    8848,
    8587,
    7851,
    7536,
    7774,
    7915,
    8211,
    8453,
    8920,
    8417,
    8552,
    8971,
    10144,
    11883,
    13742,
    15085,
    15901,
    16278,
    15871,
    15537,
    15442,
    12888,
    11238,
    10935,
    10774,
    10285,
    9829,
    9667,
    9383,
    9043,
    9125,
    8857
  ],
  [
    13856,
    12831,
    12162,
    10188,
    10319,
    9380,
    11377,
    12887,
    14023,
    15495,
    17976,
    19739,
    18108,
    18277,
    16717,
    14829,
    13833,
    13888,
    13772,
    13933,
    13883,
    14404,
    13377,
    13236,
    13429,
    14953,
    17110,
    19422,
    20648,
    21046,
    21011,
    19682,
    19250,
    18626,
    15316,
    12971,
    12405,
    12042,
    11409,
    10824,
    10429,
    9914,
    9376,
    9249,
    8857
  ]
];
const datasetBorderColor = '#';
const chartSpec = {
  labels: chartFormatting.determineXLabels(),
  datasets: [
    {
      backgroundColor: '#7ddcc6',
      borderColor: datasetBorderColor,
      borderWidth: 1,
      data: data[0],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    },
    {
      backgroundColor: '#37B1DF',
      borderColor: datasetBorderColor,
      borderWidth: 1,
      data: data[1],
      pointRadius: 0,
      pointHoverRadius: 0,
      lineTension: 0.4
    }
  ]
};
const chartOptions = {
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 500
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: true,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 3,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-Axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'PremiumsPerPhysicianChart',
  extends: Line,
  data: function () {
    return {
      chartSpec: chartSpec,
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 50);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      const eventDetail = (event.detail.detail !== undefined) ? event.detail.detail : event.detail;
      if (!eventDetail.classList.contains('chart-container-outer') ||
        !eventDetail.classList.contains('chart-container-premiums-per-physician')) return;
      document.removeEventListener('aos:in', this.aosChartEvent);
      this.render();
    },
    render: function () {
      this.renderChart(this.chartSpec, this.chartOptions);
    },
    resize: function () {
      this.chartSpec.labels = chartFormatting.determineXLabels();
      /* eslint-disable */
      if ($(window).width() <= 400) {
        this.chartOptions.layout.padding.bottom = 120;
      } else if ($(window).width() >= 401 && $(window).width() < 500) {
        this.chartOptions.layout.padding.bottom = 180;
      } else if ($(window).width() >= 501 && $(window).width() < 600) {
        this.chartOptions.layout.padding.bottom = 250;
      } else if ($(window).width() >= 601 && $(window).width() < 749) {
        this.chartOptions.layout.padding.bottom = 300;
      } else if ($(window).width() >= 750 && $(window).width() < 999) {
        this.chartOptions.layout.padding.bottom = 400;
      } else if ($(window).width() >= 1000) {
        this.chartOptions.layout.padding.bottom = 500;
      }
      /* eslint-enable */
      this.render();
    }
  }
};
</script>
